import Vue from 'vue'
import '@/layout/layout-2024.css'
import 'vue-material/dist/vue-material.min.css'
import 'vue-material/dist/theme/default.css'
import App from './layout/App.vue'
import { sync } from 'vuex-router-sync'
import { i18n, router } from './config'
import store from './store'

sync(store, router)

new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app')
